import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { CHART_COLORS, CHART_INK, formatDayLabel } from './common';

interface TrendLineChartProps {
  data: Array<Record<string, number | string>>;
  dataKey: string;
  name: string;
  color?: string;
  valueFormatter?: (value: number) => string;
  xKey?: string;
  labelFormatter?: (value: string) => string;
}

/** Single-series trend line (e.g. credits issued, active players). */
const TrendLineChart: React.FC<TrendLineChartProps> = ({
  data,
  dataKey,
  name,
  color = CHART_COLORS.net,
  valueFormatter = (v) => (Number.isFinite(v) ? v.toLocaleString('en-US') : '0'),
  xKey = 'date',
  labelFormatter = formatDayLabel,
}) => (
  <ResponsiveContainer width="100%" height="100%">
    <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={CHART_INK.grid} vertical={false} />
      <XAxis
        dataKey={xKey}
        tickFormatter={labelFormatter}
        tick={{ fontSize: 11, fill: CHART_INK.muted }}
        tickLine={false}
        axisLine={false}
        minTickGap={16}
      />
      <YAxis
        tickFormatter={valueFormatter}
        tick={{ fontSize: 11, fill: CHART_INK.muted }}
        tickLine={false}
        axisLine={false}
        width={60}
        allowDecimals={false}
      />
      <Tooltip
        labelFormatter={(label) => labelFormatter(String(label))}
        formatter={(value: number) => [valueFormatter(value), name]}
        contentStyle={{ borderRadius: 10, border: `1px solid ${CHART_INK.grid}`, fontSize: 12 }}
      />
      <Line
        isAnimationActive={false}
        type="monotone"
        dataKey={dataKey}
        name={name}
        stroke={color}
        strokeWidth={2}
        dot={false}
        activeDot={{ r: 4, strokeWidth: 2, stroke: '#ffffff' }}
      />
    </LineChart>
  </ResponsiveContainer>
);

export default TrendLineChart;
